import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Dropdown } from 'react-bootstrap';

//actions
import { showModal } from '../../../actions/modalsActions';
import { changeToBreach, updateItemData } from '../../../actions/AdminActions';
import { addBreachToBlog, removeBreachFromBlog } from '../../../actions/Dashboard/mainDashboardActions';

//icons
import { Icon } from '@iconify/react';
import baselineEventNote from '@iconify/icons-ic/baseline-event-note';

const AdminMenu = ({ item }) => {
  //redux store
  const dispatch = useDispatch();

  //local
  const [addToBlogLoading, setAddToBlogLoading] = useState(false);

  const onAddToBlogClick = async () => {
    setAddToBlogLoading(true);
    dispatch(addBreachToBlog(item._id, () => { setAddToBlogLoading(false); }));
    document.body.click();
  };

  const onRemoveFromClick = async () => {
    setAddToBlogLoading(true);
    dispatch(removeBreachFromBlog(item._id, () => { setAddToBlogLoading(false); }));
    document.body.click();
  };


  return (
    <>
      <Dropdown.Item eventKey="1">
        <div className="d-flex align-content-center"
          onClick={() => {
            dispatch(showModal('EDIT_ITEM', { title: 'Edit Item', dialogClassName: 'exist-relations', item: item }));
            document.body.click();
          }}>
          <i className="material-icons-outlined" style={{ fontSize: '20px' }}>edit</i>
          <span className="menu-item">Edit</span>
        </div>
      </Dropdown.Item>
      <Dropdown.Item eventKey="2">
        <div className="d-flex align-content-center" onClick={() => {
          dispatch(showModal('ADD_EXISTING_RELATIONS', { title: 'Add Existing Related Item', dialogClassName: 'exist-relations', item: item }));
          document.body.click();
        }}>
          <i className="material-icons-outlined" style={{ fontSize: '22px' }}>account_tree</i>
          <span className="menu-item">Add existing Related</span>
        </div>
      </Dropdown.Item>
      <Dropdown.Item eventKey="3">
        <div className="d-flex align-content-center" onClick={() => {
          dispatch(showModal('ADD_RELATED_STORY', { title: 'Add Related Story', dialogClassName: 'exist-relations', item: item }));
          document.body.click();
        }}>
          <i className="material-icons-outlined" style={{ fontSize: '22px' }}>menu_book</i>
          <span className="menu-item">Add related story</span>
        </div>
      </Dropdown.Item>
      <Dropdown.Item eventKey="4">
        <div className="d-flex align-content-center" onClick={() => {
          dispatch(showModal('ADD_RELATED_BREACH', { title: 'Add Related Breach', dialogClassName: 'exist-relations', item: item }));
          document.body.click();
        }}>
          <i className="material-icons-outlined" style={{ fontSize: '22px' }}>lock_open</i>
          <span className="menu-item">Add related breach</span>
        </div>
      </Dropdown.Item>
      <Dropdown.Item eventKey="4">
        <div className="d-flex align-content-center" onClick={() => {
          dispatch(changeToBreach(item._id));
          document.body.click();
        }}>
          <i className="material-icons-outlined" style={{ fontSize: '22px' }}>lock_open</i>
          <span className="menu-item">Change To Breach</span>
        </div>
      </Dropdown.Item>
      <Dropdown.Item eventKey="5">
        <div className="d-flex align-content-center" onClick={() => {
          dispatch(updateItemData(item._id, { mainCategoryType: 'CYBER STORY', newTag5: 'Article', label: 'Not Breach' }));
          document.body.click();
        }}>
          <i className="material-icons-outlined" style={{ fontSize: '22px' }}>menu_book</i>
          <span className="menu-item">Not A Breach</span>
        </div>
      </Dropdown.Item>
      <Dropdown.Item eventKey="6">
        <div className="d-flex align-content-center" onClick={() => {
          dispatch(updateItemData(item._id, { mainCategoryType: 'CYBER STORY', newTag5: 'Vulnerability', label: 'Vulnerability' }));
          document.body.click();
        }}>
          <i className="material-icons-outlined" style={{ fontSize: '22px' }}>report_problem</i>
          <span className="menu-item">Vulnerability</span>
        </div>
      </Dropdown.Item>
      <Dropdown.Item eventKey="6">
        <div className="d-flex align-content-center" onClick={() => {
          dispatch(updateItemData(item._id, { mainCategoryType: 'CYBER STORY', newTag5: 'Solution', label: 'Solution' }));
          document.body.click();
        }}>
          <i className="material-icons-outlined" style={{ fontSize: '22px' }}>emoji_objects</i>
          <span className="menu-item">Solution</span>
        </div>
      </Dropdown.Item>

      {item.blog === true && <Dropdown.Item eventKey="6">
        <div className="d-flex align-content-center" onClick={onRemoveFromClick}>
          <Icon className="share-block__icon" icon={baselineEventNote} style={{ fontSize: '20px' }} />
          <span className="menu-item">Remove from Blog</span>
        </div>
      </Dropdown.Item>}

      {!item.blog && <Dropdown.Item eventKey="6">
        <div className="d-flex align-content-center" onClick={onAddToBlogClick}>
          <Icon className="share-block__icon" icon={baselineEventNote} style={{ fontSize: '20px' }} />
          <span className="menu-item">Add to Blog</span>
        </div>
      </Dropdown.Item>}
    </>
  );
};

export default AdminMenu;
